'use strict'

const skinsJson = require('./skins/skins.json.js')
const wixSkinOnly = require('../wixSkinOnly/wixSkinOnly')

const getComponentSkins = () => skinsJson

module.exports = wixSkinOnly('VerticalLine', getComponentSkins)